/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components" endpoint.
 * Returns the creative components available to this DSA: every component in
 * CreativeComponents::USER_FACING_ROLLOUT, with its input-shape type and active variant count.
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdCreativeComponents } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponents = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdCreativeComponents,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsResult> => {
    return fetch(`/decisioning_studio_agents/${appGroupId}/${dsaId}/creative_components`, "GET", {}, { signal });
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsResult
);
